"use client"

import {GrowthBook} from "@growthbook/growthbook"
import {GrowthBookProvider} from "@growthbook/growthbook-react"
import {type PropsWithChildren, useEffect, useMemo, useState} from "react"
import Cookies from "js-cookie"
import {getDeviceType} from "@/app/utils/device"
import {CookiesEnum} from "@/app/enums/Cookies"
import getGrowthbookConfig from "@/app/lib/Growthbook/getGrowthbookConfig"

export default function GrowthbookClient({children}: PropsWithChildren) {
    const [isInitialized, setIsInitialized] = useState(false)
    const uuidCookie = Cookies.get(CookiesEnum.GBUUID)

    // Create GrowthBook instance once
    const gb = useMemo(() => {
        const config = getGrowthbookConfig(uuidCookie)
        const gb = new GrowthBook(config)
        return gb
    }, [uuidCookie])

    useEffect(() => {
        const initGrowthBook = async () => {
            try {
                await gb.init({
                    streaming: true,
                })

                gb.setAttributes({
                    deviceType: getDeviceType(),
                })

                setIsInitialized(true)
            } catch (error) {
                console.error("Error initializing GrowthBook:", error)
                setIsInitialized(false)
            }
        }

        initGrowthBook()

        // Cleanup function
        return () => {
            gb.destroy()
        }
    }, [gb])

    // Render with GrowthBook provider when everything is ready
    return <GrowthBookProvider growthbook={gb}>{children}</GrowthBookProvider>
}
